import Container from '@/components/atoms/Container'
import classNames from 'classnames'
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { twMerge } from 'tailwind-merge'
import LinkManager from '@/utils/helpers/LinkManager'
import useIsCurrentLink from '@/utils/hooks/useIsCurrentLink'
import { AvailableCourses } from './AvailableCourses'
import { CompleteCourses } from './CompleteCourses'

export function List() {
	const { pathname } = useLocation()

	const baseUrl = '/'
	const linkManager = new LinkManager(baseUrl)

	function createLink(to: string) {
		return linkManager.create(to)
	}

	function useIsCurrentLink_(to: string) {
		return !!useIsCurrentLink(createLink(to))
	}

	const navItens = [
		{
			label: 'Cursos Disponíveis',
			link: createLink('/'),
			current: useIsCurrentLink_('/'),
		},
		{
			label: 'Cursos Completos',
			link: createLink('/cursos-concluidos'),
			current: useIsCurrentLink_('/cursos-concluidos'),
		},
	]

	const components = {
		[createLink('/')]: <AvailableCourses />,
		[createLink('/cursos-concluidos')]: <CompleteCourses />,
	}

	return (
		<Container className='py-10 relative'>
			<div className='flex flex-col md:flex-row max-w-max gap-4 md:gap-3'>
				{navItens?.map((item, key) => {
					return (
						<Link
							key={key}
							to={item.link}
							className={twMerge(
								'flex items-center gap-2 py-3 px-3 font-semibold leading-none text-white opacity-80 hover:opacity-100 transition-opacity',
								classNames({
									'opacity-100 bg-brand-primary text-brand-text-primary rounded-lg':
										item.current,
								})
							)}
						>
							{item.label}
						</Link>
					)
				})}
			</div>

			{components[pathname]}
		</Container>
	)
}
